export default "__VITE_ASSET__DqT8dCER__"